function init3DSFilters() {
  var threeds_method_radio_yes = $('#search_threeds_method_eq_yes');
  var threeds_method_radio_no = $('#search_threeds_method_eq_no');
  var threeds_method_status_cb = $('#threeds_method_status');

  var handle_3ds_method_change = function handle_3ds_method_change() {
    if (this.checked) {
      threeds_method_status_cb.val([]);
      threeds_method_status_cb.trigger('chosen:updated');
    }
  };

  threeds_method_radio_yes.on('change', handle_3ds_method_change);
  threeds_method_radio_no.on('change', handle_3ds_method_change);

  var handle_3ds_method_status_change = function handle_3ds_method_status_change() {
    threeds_method_radio_yes.prop('checked', false);
    threeds_method_radio_no.prop('checked', false);
  };

  threeds_method_status_cb.on('change', handle_3ds_method_status_change);
}

export default {
  init3DSFilters: init3DSFilters
};